export const BASE_URL_FRONT = process.env.REACT_APP_BASE_URL_FRONT || 'http://localhost:3000';
const MODE = process.env.REACT_APP_MODE || "DEV";
export const IS_MODE_DEV = MODE === "DEV"
export const IS_MODE_PROD = !IS_MODE_DEV